import { ConteudoEletronicoModel } from './../../model/caixa/conteudoeletronico.model';
import { Observable } from 'rxjs/Observable';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Injectable } from '@angular/core';

@Injectable()
export class ConteudoEletronicoService {

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpClient: HttpClient) { }

  adicionarConteudoEletronico(conteudosEle: any, conteudoId: number): Observable<Array<ConteudoEletronicoModel>> {
    return this.httpClient.post<any>(this.apiURL + `/new/adicionar-conteudo-eletronico/${conteudoId}`, conteudosEle, this.httpOptions);
  }

  listarConteudosEle(conteudoId: number): Observable<Array<ConteudoEletronicoModel>> {
    return this.httpClient.get<Array<ConteudoEletronicoModel>>(this.apiURL + `/view/listar-conteudo-eletronico/${conteudoId}`, this.httpOptions);
  }

  deleteConteudoEle(conteudoEleId: number) {
    const headers = new HttpHeaders()
    .set('ticket', sessionStorage.getItem('ticket-ECM'))
    .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.delete(this.apiURL + `/delete/apagar-conteudo-eletronico/${conteudoEleId}`, { headers, responseType: 'text' });
  }

  listagemConteudoEle(conteudoId: number) {
    return this.httpClient.get<any>(this.apiURL + `/view/get-conteudo-eletronico-by-conteudo/${conteudoId}`, this.httpOptions);
  }

}



// WEBPACK FOOTER //
// /app/src/app/service/caixa/conteudo-eletronico.service.ts